import { NativeModules } from 'react-native';

const { PersonaInquiry2 } = NativeModules;

export class Versions {
  /**
   * @return version of the underlying Android/iOS Inquiry SDK
   */
  static nativeSdkVersion(): String {
    return PersonaInquiry2.getConstants().INQUIRY_SDK_VERSION;
  }
}
